
      import API from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../frontend/client/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../frontend/client/node_modules/css-loader/dist/cjs.js??clonedRuleSet-7.use[1]!../../../../../../../frontend/client/node_modules/vue-loader/dist/stylePostLoader.js!./NutzerschlagwortBadge.css?vue&type=style&index=0&lang=css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../frontend/client/node_modules/css-loader/dist/cjs.js??clonedRuleSet-7.use[1]!../../../../../../../frontend/client/node_modules/vue-loader/dist/stylePostLoader.js!./NutzerschlagwortBadge.css?vue&type=style&index=0&lang=css";
       export default content && content.locals ? content.locals : undefined;
